import { render, staticRenderFns } from "./vkDialog.vue?vue&type=template&id=633a97c6&scoped=true"
import script from "./vkDialog.vue?vue&type=script&lang=js"
export * from "./vkDialog.vue?vue&type=script&lang=js"
import style0 from "./vkDialog.vue?vue&type=style&index=0&id=633a97c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633a97c6",
  null
  
)

export default component.exports